import React from 'react';
import BoxIcon from 'assets/icons/BoxIcon';
import BasicButton from '../@common/Buttons/BasicButton';
import { translate } from '../../translations/translator';
import { activeGreen } from '../../styles/style-constants';
import { adjustColor, remCalc } from '../../util/style-util';
import { makeStyles } from '@mui/styles';

const translateBookMenus = key => translate('bookMenus', key);

type Props = {
  disabled: boolean;
  buttonStyles: string;
  onClick?: any;
};

const useStyles = makeStyles(() => ({
  goButton: {
    flex: 2,
    maxWidth: remCalc(140),
    paddingTop: remCalc(2)
  }
}));

const GoButton = ({ disabled, buttonStyles, ...props }: Props) => {
  const classes = useStyles();
  return (
    <BasicButton disabled={disabled} buttonStyles={[classes.goButton, buttonStyles]} {...props}>
      <BoxIcon
        fill={disabled ? adjustColor(activeGreen, -50) : activeGreen}
        text={translateBookMenus('go')}
      />
    </BasicButton>
  );
};

export default GoButton;
